import angular from 'angular';
import insuranceAllocatedAdviser from './insuranceAllocatedAdviser';

export default angular
  .module('components.insuranceAllocatedAdviser', [])
  .component('insuranceAllocatedAdviser', insuranceAllocatedAdviser).name;
